
// export const getUserAttendanceDetails = `
// query GetCalendarUserAttendanceDetails($id: String!) {
//     calanderUserAttendanceDetails(id: $id) {
//       data {
//         id
//         user {
//           id
//           username
//         }
//         checkIn
//         checkOut
//         totalWorkingHours
//         overtime
//       }
//       totalPresentDays
//       success
//       error
//       message
//     }
//   }
//  `;

export const getUserAttendanceDetails = `
query AllUserMonthlyAttendance(
  $month: Int!
  $year: Int!
  $empid: String
  $teamleader: String
) {
  allUserMonthlyAttendance(
    month: $month
    year: $year
    empid: $empid
    teamleader: $teamleader
  ) {
    success
    error
    message
    user {
      empid
      firstName
      lastName
      summary{
        totalDays
        totalPresentDays
        totalLeave
        lopDays
        totalWeekoff
        totalHolidays       
      }
      dates {
        date
        events {
          eventType
          title
          startTime
          endTime
          status
          dataId
          description
        }
      }	
    }
  }
}
`;

export const leaveDetails = `
query leaveTrackDetails($empoloyeeid: String!) {
  leaveRequestsByMe(id: $empoloyeeid) {
  data{
  id
    user {
      id
      empid
      username
    }
    requestedOn
    leaveType {
      name
    }
    leaveFrom
    leaveTill
    reason
    totalDays
    teamApproval
    hrApproval
    status
  }
  }
}
`;